import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconListSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconListSparkle"><Path d="M3 5V6.5H21V5H3Z" fill="currentColor"/><Path d="M17 8.82295L14.941 12.941L10.8229 15L14.941 17.059L17 21.1771L19.059 17.059L23.177 15L19.059 12.941L17 8.82295Z" fill="currentColor"/><Path d="M3 11.25V12.75H10V11.25H3Z" fill="currentColor"/><Path d="M3 17.5V19H8V17.5H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconListSparkle;
